const PropTypes = require('prop-types');
/**
 * Created by adderlyjaureguicampos on 13/12/16.
 */
const React = require('react');

const { formatText } = require('core/i18n').i18n;
const OKSelect = require('components/commons/OKSelect/OKSelect');
const mockHelper = require('../../../utilities/mockDataHelper');

class WorkType extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <div className="ok-slider__text">{formatText('contractsView-checkingAccountWorkTypeTitle')}</div>
                <OKSelect
                    placeholder={formatText('contractsView-checkingAccountWorkTypePlaceholder')}
                    searchable={true}
                    options={mockHelper.mockWorkType()}
                    onChange={this.props.handleOnChange}
                    value={this.props.selectedWorkType}
                />
            </div>
        );
    }
}

WorkType.propTypes = {
    handleOnChange: PropTypes.func,
    selectedWorkType: PropTypes.number
};

module.exports = WorkType;